<div class="header-content">
  <div class="wrapper-compact-wide">
    <h1>
      Cookiebeleid
    </h1>
  </div>
</div>

<div class="text-wrap">
  <div class="content-terms">
    <p><strong>Cookiebeleid Viteezy (NutraVira B.V.)</strong></p>
    <p>Laatst bijgewerkt: 5 oktober 2026</p>

    <p><strong>1. Over dit cookiebeleid</strong></p>
    <p>
      Dit cookiebeleid legt uit welke cookies en vergelijkbare technieken wij op viteezy.nl gebruiken, waarom wij dat
      doen, hoe lang de gegevens bewaard worden en hoe je jouw keuze op elk moment kunt wijzigen. Dit beleid hoort bij
      ons <a href="/privacy">privacybeleid</a>, waarin staat hoe wij persoonsgegevens in het algemeen verwerken.
    </p>
    <p>
      Verwerkingsverantwoordelijke is NutraVira B.V., handelend onder de naam Viteezy. Vragen over cookies of over jouw
      persoonsgegevens kun je stellen via <a href="mailto:info&#64;viteezy.nl">info&#64;viteezy.nl</a>.
    </p>

    <p><strong>2. Wat zijn cookies?</strong></p>
    <p>
      Cookies zijn kleine tekstbestanden die bij een bezoek aan de website op jouw computer, tablet of telefoon worden
      opgeslagen. Wij scharen hieronder ook vergelijkbare technieken zoals local storage, session storage en pixels
      (kleine, onzichtbare afbeeldingen waarmee gedrag gemeten wordt). Waar hieronder &lsquo;cookies&rsquo; staat,
      bedoelen wij al deze technieken.
    </p>

    <p><strong>3. Jouw toestemming</strong></p>
    <p>
      Noodzakelijke cookies plaatsen wij altijd: zonder deze cookies werkt de website niet. Hiervoor is op grond van
      artikel 11.7a van de Telecommunicatiewet geen toestemming vereist. Analytische en marketingcookies plaatsen wij
      alleen nadat jij daar via onze cookiemelding toestemming voor hebt gegeven. Die toestemming is de grondslag voor
      deze verwerking op grond van artikel 6 lid 1 sub a van de AVG.
    </p>
    <p>
      Kies je voor &lsquo;Alleen noodzakelijke&rsquo;, dan worden analytische en marketingcookies niet geplaatst en
      worden de bijbehorende scripts niet geladen. Jouw keuze bewaren wij 12 maanden in de cookie
      <em>viteezy_consent</em>. Daarna vragen wij het opnieuw. Ook als wij nieuwe cookies gaan gebruiken, vragen wij
      opnieuw om toestemming.
    </p>
    <p>
      Je kunt jouw keuze op elk moment wijzigen of intrekken. Het intrekken van toestemming is net zo eenvoudig als het
      geven ervan en heeft geen gevolgen voor de rechtmatigheid van de verwerking vóór de intrekking.
    </p>
    <button type="button" class="cookie-settings-button" (click)="openSettings()">Cookie-instellingen wijzigen</button>

    <p><strong>4. Noodzakelijke cookies</strong></p>
    <p>
      Deze cookies zijn nodig om de website te laten werken: om je ingelogd te houden, je winkelmandje en
      quiz-antwoorden te onthouden, betalingen af te handelen en de website te beveiligen. Zonder deze cookies kun je
      geen bestelling plaatsen. Ze worden altijd geplaatst en bevatten geen gegevens die wij voor advertenties
      gebruiken.
    </p>
    <div class="cookie-table-scroll">
      <table class="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Aanbieder</th>
            <th>Doel</th>
            <th>Bewaartermijn</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>viteezy_consent</td>
            <td>Viteezy</td>
            <td>Bewaart jouw cookiekeuze, zodat wij die niet elk bezoek opnieuw hoeven te vragen.</td>
            <td>12 maanden</td>
          </tr>
          <tr>
            <td>Sessie- en inlogcookies</td>
            <td>Viteezy</td>
            <td>Houden je ingelogd en koppelen je bestelling aan de juiste sessie.</td>
            <td>Sessie tot maximaal 12 maanden</td>
          </tr>
          <tr>
            <td>Winkelmandje en quizvoortgang</td>
            <td>Viteezy</td>
            <td>Onthouden je samenstelling en antwoorden tijdens het invullen van de quiz.</td>
            <td>Sessie</td>
          </tr>
          <tr>
            <td>Betaal- en beveiligingscookies</td>
            <td>Mollie</td>
            <td>Wikkelen de betaling af en beschermen tegen fraude en misbruik.</td>
            <td>Sessie tot maximaal 12 maanden</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p><strong>5. Analytische cookies</strong></p>
    <p>
      Met deze cookies meten wij hoe de website gebruikt wordt: welke pagina&rsquo;s bezocht worden, waar bezoekers
      vastlopen en hoe de quiz presteert. Wij gebruiken dat om de website te verbeteren. Deze cookies plaatsen wij
      alleen met jouw toestemming.
    </p>
    <div class="cookie-table-scroll">
      <table class="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Aanbieder</th>
            <th>Doel</th>
            <th>Bewaartermijn</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>_ga, _ga_*</td>
            <td>Google (Google Analytics via Google Tag Manager)</td>
            <td>Onderscheidt bezoekers en sessies om websitestatistieken op te bouwen.</td>
            <td>Tot 24 maanden</td>
          </tr>
          <tr>
            <td>_clck, _clsk</td>
            <td>Microsoft (Clarity)</td>
            <td>Legt klikgedrag, schermopnames en heatmaps vast om gebruiksproblemen te vinden.</td>
            <td>_clck 12 maanden, _clsk 1 dag</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p><strong>6. Marketingcookies</strong></p>
    <p>
      Met deze cookies kunnen wij en onze partners advertenties tonen die aansluiten bij jouw interesses, meten of een
      advertentie tot een bestelling heeft geleid, en je relevante e-mails sturen. Ook onze chatfunctie valt hieronder.
      Deze cookies plaatsen wij alleen met jouw toestemming.
    </p>
    <div class="cookie-table-scroll">
      <table class="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Aanbieder</th>
            <th>Doel</th>
            <th>Bewaartermijn</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>_fbp, _fbc</td>
            <td>Meta (Facebook en Instagram)</td>
            <td>Meet advertentieresultaten en maakt het tonen van advertenties op Meta-platforms mogelijk.</td>
            <td>Tot 3 maanden</td>
          </tr>
          <tr>
            <td>__kla_id</td>
            <td>Klaviyo</td>
            <td>Herkent je voor e-mailmarketing en meet welke e-mails tot een bezoek leiden.</td>
            <td>Tot 24 maanden</td>
          </tr>
          <tr>
            <td>Awin-cookies</td>
            <td>Awin</td>
            <td>Registreert via welke partner of affiliate je bij ons terechtkwam, zodat commissie klopt.</td>
            <td>Tot 12 maanden</td>
          </tr>
          <tr>
            <td>Nudge</td>
            <td>Nudge</td>
            <td>Toont pop-ups en acties op de website en meet of je daarop reageert.</td>
            <td>Tot 12 maanden</td>
          </tr>
          <tr>
            <td>Gorgias-chat</td>
            <td>Gorgias</td>
            <td>Laat de chat werken en onthoudt een lopend gesprek met onze klantenservice.</td>
            <td>Tot 12 maanden</td>
          </tr>
          <tr>
            <td>Advertentiecookies via Google Tag Manager</td>
            <td>Google</td>
            <td>Meet advertenties en conversies en maakt remarketing mogelijk.</td>
            <td>Tot 24 maanden</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p><strong>7. Doorgifte buiten de Europese Economische Ruimte</strong></p>
    <p>
      Google, Meta, Microsoft, Klaviyo en Gorgias zijn gevestigd in de Verenigde Staten of verwerken daar gegevens.
      Doorgifte vindt plaats op basis van het EU-VS Data Privacy Framework of, waar dat niet van toepassing is, op basis
      van de modelcontractbepalingen van de Europese Commissie met aanvullende waarborgen. Kies je voor &lsquo;Alleen
      noodzakelijke&rsquo;, dan vindt deze doorgifte via cookies niet plaats.
    </p>

    <p><strong>8. Jouw rechten</strong></p>
    <p>
      Je hebt op grond van de AVG het recht op inzage in jouw persoonsgegevens, op rectificatie, op verwijdering, op
      beperking van de verwerking, op bezwaar tegen de verwerking en op overdraagbaarheid van jouw gegevens. Ook mag je
      een gegeven toestemming op elk moment intrekken. Stuur jouw verzoek naar
      <a href="mailto:info&#64;viteezy.nl">info&#64;viteezy.nl</a>; wij reageren binnen één maand.
    </p>
    <p>
      Ben je het niet eens met hoe wij met jouw gegevens omgaan, dan kun je een klacht indienen bij de Autoriteit
      Persoonsgegevens, Postbus 93374, 2509 AJ Den Haag.
    </p>

    <p><strong>9. Cookies verwijderen via je browser</strong></p>
    <p>
      Naast onze cookiemelding kun je cookies ook zelf beheren in je browser. In Chrome, Safari, Firefox en Edge vind je
      die instellingen onder privacy en beveiliging. Verwijder je onze cookies, dan verdwijnt ook jouw bewaarde keuze en
      vragen wij bij je volgende bezoek opnieuw om toestemming. Het blokkeren van noodzakelijke cookies kan ertoe leiden
      dat delen van de website niet meer werken.
    </p>

    <p><strong>10. Wijzigingen</strong></p>
    <p>
      Wij passen dit cookiebeleid aan wanneer onze website of de door ons gebruikte diensten wijzigen. De datum bovenaan
      deze pagina geeft aan wanneer het beleid voor het laatst is gewijzigd. Bij wijzigingen die nieuwe cookies
      betreffen, vragen wij opnieuw om jouw toestemming.
    </p>
  </div>
</div>
